import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from "jwt-decode"; 
import api from '../api/axios'; 

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                // Check expiration
                if (decoded.exp * 1000 < Date.now()) {
                    logout();
                } else {
                    setUser(decoded); 
                }
            } catch (error) {
                logout();
            }
        }
        setLoading(false);
    }, [token]);

    // Login 
    const login = async (username, password) => {
        try {
            
            const response = await api.post('/auth/login', { username, password }); 
            

            const newToken = response.data.token; 

            localStorage.setItem('token', newToken);
            setToken(newToken);
            
            const decoded = jwtDecode(newToken);
            setUser(decoded);
            
            return true; 
        } catch (error) {
            console.error("Login failed", error);
            throw error;
        }
    };

    // Logout 
    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);